/* Settings → Design: Sprache, Design und eigene Farben. */
import { useSyncExternalStore } from 'react';
import I18n from '../i18n.ts';
import Theme from '../theme.js';
import { DialogBody } from './dialog.tsx';
import { useT } from './hooks.ts';

interface ThemeState { theme: string; custom: Record<string, Record<string, string>> }

export function DesignTab() {
  const t = useT();
  // Der Designzustand wird an einer Stelle verändert (Theme); die Zeichenkette ist ein stabiler Schnappschuss für React
  const st: ThemeState = JSON.parse(useSyncExternalStore((cb) => Theme.onChange(cb), () => JSON.stringify(Theme.state)));
  const themes: Record<string, { name: string; skin: boolean }> = Theme.THEMES;
  const custom = Object.keys(st.custom[st.theme] || {}).length;
  const tokens: string[][] = Theme.TOKENS.filter((k: string[]) => k[0] !== 'hl' || themes[st.theme].skin);

  return (
    <DialogBody>
      <fieldset>
        <legend>{t('settings.language')}</legend>
        <div className="row">
          <label htmlFor="xf-lang">{t('settings.language')}</label>
          <select id="xf-lang" className="sel" value={I18n.lang} onChange={(e) => I18n.setLang(e.target.value)}>
            {Object.keys(I18n.LANGS).map((id) => <option key={id} value={id}>{(I18n.LANGS as Record<string, string>)[id]}</option>)}
          </select>
        </div>
      </fieldset>
      <fieldset>
        <legend>{t('settings.look')}</legend>
        <div className="row">
          <label htmlFor="xf-theme">{t('settings.tab_design')}</label>
          <select id="xf-theme" className="sel" value={st.theme} onChange={(e) => Theme.setTheme(e.target.value)}>
            {Object.keys(themes).map((id) => <option key={id} value={id}>{t(themes[id].name)}</option>)}
          </select>
        </div>
        <p className="small">{t('settings.steam_note')}</p>
      </fieldset>
      <fieldset>
        <legend>{t('settings.colors')}</legend>
        <div className="themegrid">
          {tokens.map((k) => (
            <label key={k[0]}>{t(k[2])}
              <input type="color" value={Theme.current(k[0])} title={t(k[2])} onChange={(e) => Theme.setColor(k[0], e.target.value)} />
            </label>
          ))}
        </div>
        <p className="small">{t('settings.colors_note') + ' ' + (custom ? t('settings.colors_custom', { count: custom }) : t('settings.colors_none'))}</p>
        <div className="row"><button className="btn" onClick={() => Theme.reset()}>{t('settings.colors_reset')}</button></div>
      </fieldset>
    </DialogBody>
  );
}
